<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
      .default-modal-body
        .d-flex.flex-wrap.justify-content-center
          b-calendar(v-model="_date" :no-key-nav="true" :min="minDate"
            label-prev-year="前の年" label-prev-month="前の月" label-current-month="今月" label-next-month="次の月" label-next-year="次の年"
            label-no-date-selected="未入力"
          )
            template(#nav-prev-year)
              span 前の年
            template(#nav-prev-month)
              span 前の月
            template(#nav-next-month)
              span 次の月
            template(#nav-next-year)
              span 次の年

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(@click="ok") {{ okButtonLabel }}
        b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### カレンダー入力モーダル
 */
@Component
export default class DatePickerModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 日付 */
  @Prop({ required: true })
  date!: string;
  /** 選択可能な最小日付 */
  @Prop({ default: null })
  minDate!: string | Date | null;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "OK" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _date(): string {
    return this.date;
  }

  set _date(newValue: string) {
    this.$emit("update:date", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
